import { Device_Type } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/device_pb.ts';
import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

export const listFirmwares = () =>
  blazeDevicePromiseClient.listFirmwares({
    pageSize: BigInt(1000),
    deviceType: Device_Type.SENTIO_CCU,
  });
